"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyTakeaways() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section ref={ref} aria-labelledby="key-takeaways-title" className={`relative w-full bg-background text-foreground py-10 sm:py-14 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div className="relative mx-auto max-w-3xl px-6 sm:px-8">
        <div className="rounded-xl border border-border bg-card p-6 sm:p-8 shadow-md">
          <h2 id="key-takeaways-title" className="font-serif text-xl sm:text-2xl font-bold tracking-tight text-foreground mb-4">
            What We Actually Fix in Your Hotel's Daily Operations
          </h2>

          <p className="font-sans text-sm sm:text-base leading-relaxed text-foreground mb-6 font-medium">
            We eliminate unauthorized OTA undercutting, automate dynamic rate adjustments to match live demand, and fix PMS-channel manager mapping errors so you sell rooms at the highest possible margin.
          </p>

          <ul className="space-y-4 font-sans text-sm sm:text-base leading-relaxed text-foreground">
            <li className="flex items-start gap-2.5">
              <span className="mt-2 size-1.5 shrink-0 rounded-full bg-secondary" aria-hidden="true" />
              <p>
                <strong className="font-semibold text-foreground">
                  Founder-Led Practice:
                </strong>{" "}
                You work directly with Sunil Singh. Over 15 years in hotel commercial distribution, fixing rate leakage and protecting take-home profit.
              </p>
            </li>
            <li className="flex items-start gap-2.5">
              <span className="mt-2 size-1.5 shrink-0 rounded-full bg-secondary" aria-hidden="true" />
              <p>
                <strong className="font-semibold text-foreground">
                  Core Focus:
                </strong>{" "}
                Daily dynamic pricing, real-time pickup pace tracking, compset yield adjustments, and channel manager mapping.
              </p>
            </li>
            <li className="flex items-start gap-2.5">
              <span className="mt-2 size-1.5 shrink-0 rounded-full bg-secondary" aria-hidden="true" />
              <p>
                <strong className="font-semibold text-foreground">
                  Channel &amp; Parity Control:
                </strong>{" "}
                Stopping unauthorized discounts on Booking.com, Agoda, MakeMyTrip, and Expedia while protecting your direct booking engine.
              </p>
            </li>
            <li className="flex items-start gap-2.5">
              <span className="mt-2 size-1.5 shrink-0 rounded-full bg-secondary" aria-hidden="true" />
              <p>
                <strong className="font-semibold text-foreground">
                  Zero-Risk Entry:
                </strong>{" "}
                A complimentary 14-day{" "}
                <Link href="https://hotelrevbaba.com/how-to-conduct-a-hotel-revenue-audit-complete-guide/" className="underline text-secondary-foreground hover:text-foreground font-semibold transition-colors">
                  revenue audit
                </Link>{" "}
                to uncover hidden extranet markdowns, rate parity violations, and inventory sync errors.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}